import { render, staticRenderFns } from "./addModule.vue?vue&type=template&id=4baa8184&"
import script from "./addModule.vue?vue&type=script&lang=js&"
export * from "./addModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports